import { zodContract } from '@leprecoins/effector-sockets';
import { createReceive } from '../socket-client';
import { shiftPersonalSchema } from '../types';

export const receiveShiftPersonal = createReceive(
	'shift-personal',
	zodContract(shiftPersonalSchema),
);
